// extracted by mini-css-extract-plugin
export var footer = "_kb-0";
export var inherit = "_kb-1";
export var input = "_kb-2";
export var modalContent = "_kb-3";
export var quillEditor = "_kb-4";
export var subtitle = "_kb-5";